import "./matchView.css";

import React from "react";
import {useSelector} from "react-redux";
import {Modal, Button, Box} from "@mui/material";

import {useAction, useTranslate} from "../../hooks";
import {MatchViewHeader, MatchViewTable} from "./components";


const MatchView = () => {
    const {isMaxTimeLeft} = useSelector(state => state.match);
    const {setIsMaxTimeLeft, setPause, setFinish} = useAction()
    const translates = useTranslate()

    const onClickButtonEndHandler = () => {
        setFinish()
        setIsMaxTimeLeft({value: false})
    }

    const onClickButtonContinueHandler = () => {
        setPause({value: false})
        setIsMaxTimeLeft({value: false})
    }

    return (
        <>
            <div className="match-view">
                <MatchViewHeader/>
                <MatchViewTable/>
            </div>
            <Modal open={isMaxTimeLeft} onClose={() => {}}>
                <Box
                    sx={{
                        bgcolor: 'background.paper',
                        boxShadow: 1,
                        borderRadius: 2,
                        p: 2,
                        width: 480,
                        margin: "auto",
                        marginTop: 20
                    }}
                >
                    <h3 className="match-view-modal-title">
                        {translates['STOP_MODAL_TEXT']}
                    </h3>
                    <div className="match-view-modal-buttons">
                        <Button
                            color="error"
                            variant="contained"
                            onClick={onClickButtonEndHandler}
                        >
                            {translates['BTN_MATCH_FINISH_TEXT']}
                        </Button>
                        <Button
                            color="success"
                            variant="contained"
                            onClick={onClickButtonContinueHandler}
                        >
                            {translates['BTN_MATCH_CONTINUE_TEXT']}
                        </Button>
                    </div>
                </Box>
            </Modal>
        </>
    )
};

export default MatchView